
const Product_Condition_ListPrice_Customer = 'CustomerList';
const Product_Condition_ListPrice_National = 'GrossList';
const Product_Condition_NetListPrice_Product = 'ProductNetListPrice';
const Product_Condition_GrossListPrice_Product = 'ProductGrossListPrice';
const Product_Condition_MarkupPct = 'MarkupPct';
const Product_Condition_COGS = 'COGS';
const Product_Condition_Cost = 'Cost';
const Product_Condition_TrueBasePrice = 'TrueBase';
const Product_Condition_BasePrice = 'RetailPrice';
const Product_Condition_VCM = 'VCM';
const Product_Condition_UnitConversionFactor = 'UCVN';
const Product_Condition_StatCSFactor = 'STAT';
const Product_Condition_WeightFactor = 'WT';
const Product_Condition_RetailPrice = 'RetailPrice';
const Product_Condition_RetailBasePrice = 'RetailerBase';
const Product_Condition_InvoiceTerms = "InvoiceTerms";
const Product_Condition_NonTradeLogistics = "NonTradeLogistics";
const Product_Condition_NonTradeProduct = "NonTradeProduct";
const Product_Condition_NonTradeOther = "NonTradeOther";
const Product_Condition_FundingRate_Base = 'FundRate';
const Product_Condition_FundingRate_Kicker = 'FundRate';
const Product_Condition_Error_WbID = -1;
const Product_Condition_Calced_WbID: number = -2;
const Product_Condition_Max_BOM_Depth: number = 3;
const Product_Condition_Default_SetID: string = "Excel";
const Product_Condition_FundTypes: string[] = ['ATL', 'BTL', 'ShopperMarketing', '003', '002', '001', 'Test Fund 123'];
//more will be defined as implementation continues

const Product_Status_Available = '03';
const Product_Type_Open_Stock = 'OpenStock';
const Product_Type_Display = 'Display';
const Product_Type_SpecialPack = 'SpecialPack';

const Product_UOM_Eaches = 'EA';


const Period_Type_Fiscal_Year = 'FiscalYear';
const Period_Type_Quarter = 'Quarter';
const Period_Type_Month = 'Month';
const Period_Type_Week = 'Week';
const Period_Type_Definitions: {FY: string, Quarter: string, Month: string, Week: string, DefaultCalcLevel: string} = {
    FY: Period_Type_Fiscal_Year,
    Quarter: Period_Type_Quarter,
    Month: Period_Type_Month,
    Week: Period_Type_Week,
    DefaultCalcLevel: Period_Type_Week};

const Workflow_Status_Type_Initial = 'Initial';
const Workflow_Status_Type_Rejected = 'Rejected';
const Workflow_Status_Type_Approved= 'Approved';
const Workflow_Status_Type_Closed= 'Closed';

const Date_Default_Interval_Length: number = 7;

const Product_Hierarchy_Default_HierID = 'Sales';
const Product_Hierarchy_Default_GrpSetID = 'HAIN';
const Product_Hierarchy_Max_Depth: number = 10;
const Product_Hierarchy_OrgLevel_Level_1 = 'Level1';
const Product_Hierarchy_OrgLevel_Level_3 = 'Level3';
const Product_Hierarchy_OrgLevel_PPG = 'Level4';
const Product_Hierarchy_OrgLevel_Product = 'Product';
const Product_Hierarchy_OrgLevel_StructuralDiscounts = "PPG";
const Product_Hierarchy_OrgLevel_MarkupPct = "Level1";
const Product_Hierarchy_Common_Levels: {PlanLevel: string, PlanPrdLevel: string, PrdLevel: string, StructureDiscount: string, MarkupPct: string} = {PlanLevel: Product_Hierarchy_OrgLevel_Level_1, PlanPrdLevel: Product_Hierarchy_OrgLevel_PPG, PrdLevel: Product_Hierarchy_OrgLevel_Product, StructureDiscount: Product_Hierarchy_OrgLevel_PPG, MarkupPct: Product_Hierarchy_OrgLevel_MarkupPct}

const Customer_Hierarchy_Max_Depth: number = 8;

const Period_Hierarchy_Max_Depth: number = 8;

export {
    Product_Condition_Error_WbID,Product_Condition_ListPrice_Customer, Product_Condition_ListPrice_National, Product_Condition_NetListPrice_Product, Product_Condition_GrossListPrice_Product, Product_Condition_MarkupPct, Product_Condition_COGS, Product_Condition_TrueBasePrice, Product_Condition_BasePrice, Product_Condition_VCM, Product_Condition_RetailPrice, Product_Condition_Cost,
    Product_Condition_InvoiceTerms, Product_Condition_NonTradeLogistics, Product_Condition_NonTradeProduct, Product_Condition_NonTradeOther, Product_Condition_FundingRate_Base, Product_Condition_FundingRate_Kicker,
    Product_Condition_Calced_WbID, Product_Condition_Max_BOM_Depth, Product_Condition_Default_SetID, Product_Condition_UnitConversionFactor, Product_Condition_StatCSFactor, Product_Condition_RetailBasePrice,
    Product_Condition_FundTypes,
    Product_Status_Available, Product_Type_Open_Stock, Product_Type_Display, Product_Type_SpecialPack,
    Product_UOM_Eaches,
    Period_Type_Definitions,
    Workflow_Status_Type_Initial,Workflow_Status_Type_Rejected,Workflow_Status_Type_Approved,Workflow_Status_Type_Closed,
    Date_Default_Interval_Length,
    Product_Hierarchy_Default_HierID, Product_Hierarchy_Default_GrpSetID, Product_Hierarchy_OrgLevel_PPG, Product_Hierarchy_OrgLevel_Product, Product_Hierarchy_Max_Depth, Product_Hierarchy_Common_Levels,
    Product_Hierarchy_OrgLevel_Level_3,
    Customer_Hierarchy_Max_Depth,
    Period_Hierarchy_Max_Depth}


